export default {
  'entityName': 'staff',
  pagination: {
    'itemsPerPage': 10,
    'page': 1,
    'sortBy': 'id',
    'descending': true
  },
  filterStorage: {},
  'fields': [

    {
      value: 'type',
      text: 'Type',
      'type': 'list',
      'table': {
        'sortable': true,
        filter: true
      },
      'list': () => {
        let types = [
          'Manager', 'Agent'
        ]
        return types
      },
      'validators': [
        'required'
      ]
    },

    {
      value: 'name',
      text: 'Name',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      render: item => `${item.name} ${item.surname}`,
      filter: (item, search) => {
        return [{
          'name': `%${search}%`
        }, {
          'surname': `%${search}%`
        }]
      },
      validators: ['required']
    },
    {
      value: 'surname',
      text: 'Surname',
      type: 'text',
      default: null,
      validators: ['required']
    },

    {
      value: 'email',
      text: 'Email',
      'type': 'text',
      'table': {
        'sortable': true,
        'filter': true
      },
      'validators': [
        'required',
        'email'
      ]
    },

    {
      value: 'phone',
      text: 'Phone',
      type: 'text',
      // table: {
      //   'sortable': true,
      //   'filter': true
      // },
      validators: [
        'required',
      ]
    },


    {
      value: 'role',
      text: 'Role',
      type: 'text',
      table: {
        sortable: true,
        filter: true
      },
      validators: [
        'required'
      ]
    },

    {
      full: true,
      value: 'prov',
      text: 'Prov',
      id: 'code',
      title: 'code',
      reference: 'country',
      type: 'autocomplete',
      multiple: true,
      visible: item => item.type == 'Agent',
      deps: ['type']
    },



    {
      full: true,
      value: "press_banners",
      text: "Banner Firma Gmail",
      multiple: true,
      chips: true,
      items: [],
      deletable_chips: true,
      placeholder: '',
      loadRemote: true,
      type: "autocomplete",
      id: "id",
      subtitle: (item) => 'From ' + (item.dateFrom ?? '...') + ' to ' + (item.dateTo ?? '...'),
      reference: "press",
      default: () => undefined,
      filter: () => ({ 'press.type': `Banner Generator`, 'press.image': '!NULL' }),
      title: (item) => item.title
    },


    {
      full: true,
      "value": "image",
      "text": "Image",
      "type": "image",
    },



  ],
  actions: [
    'upsert', 'remove'
  ]
}